import { useTranslation } from 'react-i18next'
import { useHomepageSection } from './useHomepageSection'

const FALLBACK_PROGRAMS = [
  {
    key: 'national',
    slug: 'NationalProgram',
    image: '/slider/001.JPG',
    gradient: 'from-primary to-secondary',
  },
  {
    key: 'british',
    slug: 'BritishProgram',
    image: '/slider/003.JPG',
    gradient: 'from-secondary to-primary',
  },
  {
    key: 'american',
    slug: 'AmericanProgram',
    image: '/slider/004.JPG',
    gradient: 'from-accent to-secondary',
  },
]

const GRADIENTS = {
  national: 'from-primary to-secondary',
  british: 'from-secondary to-primary',
  american: 'from-accent to-secondary',
}

const PROGRAM_COUNTRY_CODES = {
  national: 'JO',
  british: 'GB',
  american: 'US',
  NationalProgram: 'JO',
  BritishProgram: 'GB',
  AmericanProgram: 'US',
}

function programCountryCode(key, slug) {
  return PROGRAM_COUNTRY_CODES[key] || PROGRAM_COUNTRY_CODES[slug] || null
}

export function useProgramsData() {
  const { t } = useTranslation()
  const cms = useHomepageSection('programs')

  const programs = cms.items.length
    ? cms.items.map((item) => {
        const link = item.link || ''
        const slug = link.replace(/^\/pages\//, '').replace(/^\//, '')
        return {
          key: item.item_key || item.id,
          slug: slug || item.item_key,
          to: link || `/pages/${item.item_key}`,
          image: item.image || '/slider/001.JPG',
          gradient: GRADIENTS[item.item_key] || 'from-primary to-secondary',
          countryCode: programCountryCode(item.item_key, slug),
          title: cms.itemText(item, 'title'),
          description: cms.itemText(item, 'content') || cms.itemText(item, 'subtitle'),
        }
      })
    : FALLBACK_PROGRAMS.map(({ key, slug, image, gradient }) => ({
        key,
        slug,
        to: `/pages/${slug}`,
        image,
        gradient,
        countryCode: programCountryCode(key, slug),
        title: t(`programs.${key}.title`),
        description: t(`programs.${key}.description`),
      }))

  return {
    cms,
    programs,
    heading: {
      label: cms.text('label', 'programs.label'),
      title: cms.text('title', 'programs.title'),
      subtitle: cms.text('subtitle', 'programs.subtitle'),
    },
  }
}
